import { Controller } from "@hotwired/stimulus"

// Enables the submit button only once some tracked field's value differs
// from what it was on page load — used by the site-notice and promotion
// settings forms (each field compared individually, so a single checkbox
// toggle among many genre checkboxes is enough to flip it).
export default class extends Controller {
  static targets = ["field", "submit"]

  connect() {
    this.initial = this.fieldTargets.map((field) => this.valueOf(field))
    this.refresh()
  }

  refresh() {
    const dirty = this.fieldTargets.some((field, index) => this.valueOf(field) !== this.initial[index])
    this.submitTarget.disabled = !dirty
  }

  valueOf(field) {
    return field.type === "checkbox" ? field.checked : field.value
  }
}
